<template>
  <div id="details">
    <!-- MENU VERTICAL -->
    <Aside />

    <!-- DETAIL DU COMMERCE -->
    <div class="details">
      <div class="detailsShop">
        <!-- <div>
					<div v-for="(trade, key) in traderArray[id]" :key="key">{{ key }} : {{ trade }}</div>
				</div> -->
        <!-- COORDONNEES -->
        <div class="detailsInfos">
          <div class="imgShop">
            <img v-if="ficheTrader[0].photo1E" :src="getImg(ficheTrader[0].photo1E)" alt="Image commerçant" />
            <img v-else src="../assets/img/content/gimont-city-square.png" alt="Eglise Gimont" />
          </div>
          <h1>{{ ficheTrader[0].denomination_socialeE }}</h1>
          <div class="getHTML" v-html="ficheTrader[0].services_et_produitsE"></div>
          <h3>{{ ficheTrader[0].activiteE }}</h3>

          <div class="contactInfos">
            <p v-if="ficheTrader[0].contact_nomE != 'NULL'">
              <span v-if="ficheTrader[0].civiliteE != 'NULL'">{{
                ficheTrader[0].civiliteE
              }}</span>
              {{ ficheTrader[0].contact_nomE }}
            </p>
            <p>{{ ficheTrader[0].adresseE }} <br> {{ ficheTrader[0].villeE }}</p>
            <p
              v-if="
                ficheTrader[0].telE != '' && ficheTrader[0].telE != 'NULL'
              "
            >
              Tél: {{ replaceCarcBySpace(ficheTrader[0].telE) }}
            </p>
          </div>

          <hr class="detailsSeparate" />

          <div class="callContact">
            <div class="detailsNum">
              <a
                :href="'tel:' + deleteCarcNum(ficheTrader[0].telE)"
                v-if="
                  ficheTrader[0].telE &&
                  ficheTrader[0].telE != '' &&
                  ficheTrader[0].telE != 'NULL'
                "
                :title="deleteCarcNum(ficheTrader[0].telE)"
                @click="showTel = !showTel"
                ><i class="fal fa-phone-alt"></i
              ></a>
              <a
                :href="`mailto:${ficheTrader[0].emailE}`"
                v-if="
                  ficheTrader[0].emailE &&
                  ficheTrader[0].emailE != '' &&
                  ficheTrader[0].emailE != 'NULL'
                "
                :title="ficheTrader[0].emailE"
                @click="showMail = !showMail"
                ><i class="fal fa-envelope"></i
              ></a>
              <a
                v-if="
                  ficheTrader[0].site_webE &&
                  ficheTrader[0].site_webE != '' &&
                  ficheTrader[0].site_webE != 'NULL'
                "
                :href="ficheTrader[0].site_webE"
                :title="ficheTrader[0].site_webE"
                target="_blank"
                rel="noopener"
                ><i class="fal fa-globe"></i
              ></a>
              <a
                v-if="
                  ficheTrader[0].facebookE &&
                  ficheTrader[0].facebookE != '' &&
                  ficheTrader[0].facebookE != 'NULL'
                "
                :href="ficheTrader[0].facebookE"
                :title="ficheTrader[0].facebookE"
                target="_blank"
                rel="noopener"
                ><i class="fab fa-facebook-f"></i
              ></a>
              <a
                v-if="
                  ficheTrader[0].instagramE &&
                  ficheTrader[0].instagramE != '' &&
                  ficheTrader[0].instagramE != 'NULL'
                "
                :href="ficheTrader[0].instagramE"
                :title="ficheTrader[0].instagramE"
                target="_blank"
                rel="noopener"
                ><i class="fab fa-instagram"></i
              ></a>
              <a
                v-if="
                  ficheTrader[0].twitterE &&
                  ficheTrader[0].twitterE != '' &&
                  ficheTrader[0].twitterE != 'NULL'
                "
                :href="ficheTrader[0].twitterE"
                :title="ficheTrader[0].twitterE"
                target="_blank"
                rel="noopener"
                ><i class="fab fa-twitter"></i
              ></a>
              <a
                v-if="
                  ficheTrader[0].linkedINE &&
                  ficheTrader[0].linkedINE != '' &&
                  ficheTrader[0].linkedINE != 'NULL'
                "
                :href="ficheTrader[0].linkedINE"
                :title="ficheTrader[0].linkedINE"
                target="_blank"
                rel="noopener"
                ><i class="fab fa-linkedin-in"></i
              ></a>
            </div>
            
          </div>
          <div>
            <div class="plus" v-if="showMail == true">
              <p>{{ficheTrader[0].emailE}}</p>
            </div>
            <div class="plus" v-if="showTel == true">
              <p>{{ficheTrader[0].telE}}</p>
            </div>
          </div>

          <div
            class="services"
            v-if="
              ficheTrader[0].commandeE == 1 ||
              ficheTrader[0].click_and_collectE == 1 ||
              ficheTrader[0].livraisonE == 1 ||
              ficheTrader[0].points_relaisE == 1
            "
          >
            <div class="detailsServices">
              <div class="boxServices" v-if="ficheTrader[0].commandeE == 1">
                <i class="fas fa-check-circle"></i>
                <h3>COMMANDE</h3>
              </div>
              <div
                class="boxServices"
                v-if="ficheTrader[0].click_and_collectE == 1"
              >
                <i class="fas fa-check-circle"></i>
                <h3>CLICK & COLLECT</h3>
              </div>
              <div class="boxServices" v-if="ficheTrader[0].livraisonE == 1">
                <i class="fas fa-check-circle"></i>
                <h3>LIVRAISON</h3>
              </div>
              <div
                class="boxServices"
                v-if="ficheTrader[0].points_relaisE == 1"
              >
                <i class="fas fa-check-circle"></i>
                <h3>POINTS RELAIS</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="colRespons">
          <!-- JOURS D'OUVERTURE -->
          <div class="businessHours">
            <h2>OUVERTURE</h2>
            <div class="allDays">
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_lundiE)"
              >
                <p class="title">LUN</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_lundiE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_mardiE)"
              >
                <p class="title">MAR</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_mardiE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_mercrediE)"
              >
                <p class="title">MER</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_mercrediE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_jeudiE)"
              >
                <p class="title">JEU</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_jeudiE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_vendrediE)"
              >
                <p class="title">VEN</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_vendrediE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_samediE)"
              >
                <p class="title">SAM</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_samediE)"
                ></p>
              </div>
              <div
                class="day"
                :class="colorHours(ficheTrader[0].ouverture_dimancheE)"
              >
                <p class="title">DIM</p>
                <p
                  class="hour"
                  v-html="deleteSlash(ficheTrader[0].ouverture_dimancheE)"
                ></p>
              </div>
            </div>
          </div>

          <!-- MAP -->
          <div id="map" :key="rerenderMap">
            <l-map :zoom="16" :center="[position[1], position[0]]">
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-marker :lat-lng="[position[1], position[0]]"></l-marker>
            </l-map>
          </div>
        </div>
      </div>
      <div class="detailsProduct">
        <div class="blockProduct">
          <!-- PRODUITS ET SERVICES -->
          <div class="descriptionProduct dP1">
            <div class="title">
              <h1>Mes produits et services</h1>
            </div>
            <div class="img">
              <img src="../assets/img/content/Successfulpurchase-bro.png" alt />
            </div>
          </div>

          <!-- ARTICLE + PROMOTIONS -->
          <div class="descriptionProduct dP2">
            <div :class="[ficheTrader[0].promotxtE && compareDates(ficheTrader[0].promo_debE, ficheTrader[0].promo_endE) ? 'description' : 'fullDescription']">
              <img v-if="ficheTrader[0].photo2E" :src="getImg(ficheTrader[0].photo2E)" alt="Image commerçant" />
              <img v-else src="../assets/img/content/CDT32_0062782.jpg" alt="Photo gimont" />
              <div class="descrText">
                <div class="getHTML"
                  v-if="
                    ficheTrader[0].descriptionE &&
                    ficheTrader[0].descriptionE.length > 255
                  "
                  v-html="showText(ficheTrader[0].descriptionE)"
                ></div>
                <div class="getHTML" v-else v-html="ficheTrader[0].descriptionE"></div>
                <a
                  v-if="
                    ficheTrader[0].descriptionE &&
                    ficheTrader[0].descriptionE.length > 255
                  "
                  @click="showFullText = !showFullText"
                  v-html="showFullText == false ? 'LIRE LA SUITE' : 'FERMER'"
                ></a>
              </div>
            </div>
            <div v-if="ficheTrader[0].promotxtE && compareDates(ficheTrader[0].promo_debE, ficheTrader[0].promo_endE)" class="promotions">
            <!-- <div v-if="ficheTrader[0].promotxtE && test(ficheTrader[0].promo_debE, ficheTrader[0].promo_endE)" class="promotions"> -->
              <div class="title">
                <h1>
                  PROMO
                  <br />du moment *
                </h1>
              </div>
              <div class="descrPromo">
                <div v-html="ficheTrader[0].promotxtE"></div>
                <p v-if="ficheTrader[0].promo_debE && ficheTrader[0].promo_endE" class="bolder">*Du {{ convertDate(ficheTrader[0].promo_debE) }} au {{ convertDate(ficheTrader[0].promo_endE) }}</p> 
                <!-- <p v-if="ficheTrader[0].promo_endE" class="bolder">Au {{ convertDate(ficheTrader[0].promo_endE) }}</p>  -->
              </div>
            </div>
          </div>

          <!-- CONTACT -->
          <!-- <div class="form">
            <h5>Contactez le commerçant</h5>
            <textarea name="contactShop" id="contactShop" cols="60" rows="5" placeholder="Saisissez votre message"></textarea>
            <div class="btnForm">
              <a href="/" class="yellowBtn">
                <i class="far fa-paper-plane"></i>
                <p>Envoyez</p>
              </a>
              <a href="/" class="yellowBtn">
                <i class="far fa-user"></i>
                <p>Identifiez-vous</p>
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div>
      <div class="fullBtn">
        <router-link to="/liste.html" class="backBtn">Liste</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Aside from "../components/Aside";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { shopMixin } from "../mixins/shopMixin";
import { titleMixin } from "../mixins/titleMixin";
import axios from "axios";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Détails d'une fiche entreprise comprenant ses coordonnées, les services proposés, mais également sa description et ses horaires d'ouverture. Vie économiques gimontoise à Gimont dans le Gers.",
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Détails fiche entreprie, Coordonnées, Services, Description, Horaires, Vie économique gimontoise, Gimont, Gers",
      },
    ],
  },
  name: "Details",
  components: {
    Aside,
    LMap,
    LTileLayer,
    LMarker,
  },
  mixins: [shopMixin, titleMixin],
  data() {
    return {
      idTrader: this.$route.params.id,
      id: 0,
      title: "",
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',

      showFullText: false,
      position: [0.87476, 43.6274],
      // position: [],
      rerenderMap: 0,
      styleObject: {
        backgroundImage: "url(../assets/img/content/gimont.jpg)",
      },
      showMail: false,
      showTel: false,
      dateDebut: "",
      dateFin: "",
    };
  },
  computed: {
    ficheTrader: function() {
      let ficheTraderArray = [];
      for(let i=0; i<this.traderArray.length; i++) {
        if(this.idTrader == this.traderArray[i].idE) {
          ficheTraderArray.push(this.traderArray[i])
        }
      }
      // console.log(ficheTraderArray)
      return ficheTraderArray
    }
  },
  beforeMount() {
    this.getID();
    this.defineTitle();
    this.getLatLong();
  },
  methods: {
    convertDate(date) {
      let cDate = new Date(date)
      
      let mounth =cDate.getMonth()+1 
      let dateC;
      if(mounth<10) {
        dateC = cDate.getDate()+'-0'+ mounth +'-'+cDate.getFullYear();
      } else {
        dateC = cDate.getDate()+'-'+ mounth +'-'+cDate.getFullYear();
      }

      // let hours;
      // if(cDate.getHours() < 10) {
      //   hours = "0"+cDate.getHours()
      // } else {
      //   hours = cDate.getHours()
      // }

      // let minutes;
      // if(cDate.getMinutes() < 10) {
      //   minutes = "0"+cDate.getMinutes()
      // } else {
      //   minutes = cDate.getMinutes()
      // }

      // let time = hours + ":" + minutes;
      // let fullDate = dateC+' à '+time;
      let fullDate = dateC;
      return fullDate
    },
    compareDates(dateDebut, dateFin) {
      let debut = new Date(dateDebut)
      var fin = new Date(dateFin)
      var currentDate = new Date();
      // console.log(debut)
      // console.log(fin)
      // console.log(currentDate)
      if (debut <= currentDate && currentDate <= fin) {
        // console.log('resultat')
        // console.log('true')
        return true;
      } else {
        // console.log('resultat')
        // console.log('false')
        return false
      }
      
    },
    getID() {
      let id;
      for(let i=0; i<this.traderArray.length; i++) {
        if(this.idTrader == this.traderArray[i].idE) {
          id = i;
        }
      }
      return id;
    },
    getLatLong() {
      let id = this.getID();
      // console.log(id)
      if (
        this.traderArray[id].gps_LongE &&
        this.traderArray[id].gps_LatE &&
        this.traderArray[id].gps_LongE != 0 &&
        this.traderArray[id].gps_LatE != 0
      ) {
        this.position = [
          this.traderArray[id].gps_LongE,
          this.traderArray[id].gps_LatE,
        ];
      } else {
        // this.position = this.getGeoCode(
        // 	this.traderArray[this.id].adresseE,
        // 	this.traderArray[this.id].cpE,
        // 	this.traderArray[this.id].villeE
        // );
        let q =
          this.traderArray[id].adresseE +
          " " +
          this.traderArray[id].cpE +
          " " +
          this.traderArray[id].villeE;

        let url =
          "https://api-adresse.data.gouv.fr/search/?q=" +
          q +
          "&type=housenumber";

        axios
          .get(url)
          .then((response) => {
            // handle success
            // console.log('result : ' + response.data.features[0].geometry.coordinates);
            this.position = response.data.features[0].geometry.coordinates;
            this.rerenderMap++;
            // console.log(this.position);
          })
          .catch((error) => {
            // handle error
            console.log(error);
          });
      }
    },

    defineTitle() {
      this.title =
        this.traderArray[this.id].denomination_socialeE +
        " Vie économique gimontoise Gimont Gers 32";
    },
    sliceText(text) {
      text = text.substr(0, 200);
      return text;
    },
    deleteSlash(day) {
      if (day) {
        day.trim();
        day = day.split("/").join("<br/>");
        return day;
      }
    },
    showText(text) {
      let a;
      if (this.showFullText == false) {
        a = this.sliceText(text) + "...";
      } else {
        a = text;
      }
      return a;
    },
    colorHours(hours) {
      let classColor;
      if (hours && hours.toUpperCase() != "FERMÉ") {
        classColor = "colored";
      }
      return classColor;
    },
    getImg(imgName) {
      return 'https://www.vie-economique-gimont.fr/medias/etablissements/' + imgName;
    }
  },
};
</script>

<style scoped>
.details,
.fullBtn {
  margin-left: 18%;
  display: flex;
  z-index: 0;
}

.details h3 {
  margin: 1rem 0 0 0;
  font-size: 0.8rem;
  color: rgb(151, 151, 151);
}

.details h2 {
  text-align: left;
  color: rgb(151, 151, 151);
  font-weight: lighter;
  margin: 1rem 0;
}

.detailsInfos h1 {
  margin: 2.5rem 0 0 0;
}

.detailsInfos h3 {
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.detailsSeparate {
  width: 80%;
  border: 1px solid rgb(231, 231, 231);
  border-top: transparent;
}

.imgShop {
  width: 80px;
  height: 80px;
  margin-top: -2.5rem;
}

.imgShop img {
  width: 100%;
  border: 1px solid transparent;
  border-radius: 100%;
  height: 100%;
}

.detailsShop,
.detailsProduct {
  width: 50%;
}

.detailsShop {
  margin: 1rem 3rem 0 3rem;
}

.blockProduct {
  margin: 1rem 3rem 1rem 3rem;
}

.detailsProduct {
  background-color: #f3d6b2;
}

.detailsInfos {
  border: 1px solid rgb(231, 231, 231);
  border-radius: 10px;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detailsInfos p,
.getHTML {
  font-size: 0.8rem;
  margin: 0.2rem;
  padding: 0;
}

.contactInfos {
  display: flex;
  justify-content: space-between;
  width: 70%;
}

.contactInfos p {
  width: 32%;
  text-align: center;
}

.callContact {
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 1rem 0;
}

.callContact i {
  cursor: pointer;
}

.detailsNum {
  font-size: 1.2rem;
  width: 60%;
  display: flex;
  justify-content: space-between;
}

.detailsNum a {
  color: #3c4652;
}

.services {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detailsServices {
  display: flex;
  justify-content: space-evenly;
  width: 94%;
  border: 1px solid rgb(231, 231, 231);
  border-radius: 10px;
  padding: 1rem;
  margin: 1rem 0;
}

.boxServices {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fa-check-circle,
.fa-times-circle {
  font-size: 1.6rem;
  margin-bottom: -0.5rem;
}

.fa-check-circle {
  /* color: rgb(255, 193, 0); */
  color: #d89747;
}

.allDays {
  border: 1px solid #3c4652;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.day {
  width: 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.day .title {
  font-weight: bold;
  margin-bottom: 0;
}

.day .hour {
  font-size: 0.6rem;
  text-align: center;
}

.colored {
  background-color: #d89747;
}

.descriptionProduct {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.dP1 {
  align-items: center;
}

.descriptionProduct .img,
.descriptionProduct .description {
  width: 50%;
}

.descriptionProduct .promotions,
.descriptionProduct .title {
  width: 43%;
}

.descriptionProduct .title h1 {
  text-align: left;
}

.descriptionProduct .img img,
.descriptionProduct .description img,
.descriptionProduct .fullDescription,
.descriptionProduct .fullDescription img {
  width: 100%;
}

.description p,
.fullDescription p {
  font-size: 0.8rem;
  margin-bottom: 0;
  margin-top: 1.5rem;
}

.description a,
.fullDescription a {
  text-decoration: underline;
  font-weight: bold;
  font-size: 0.8rem;
  cursor: pointer;
}

.promotions .title {
  background-image: url(../assets/img/wallpapers/fondPromo.fw.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.promotions .title h1 {
  margin: 0;
  text-align: center;
}

.promotions .descrPromo {
  background-color: white;
  padding: 1rem 1rem 0.5rem 1rem;
}

.promotions .descrPromo p {
  font-size: 0.7rem;
}

.promotions .descrPromo .bolder {
  font-weight: bolder;
  font-size: 0.8rem;
  margin-bottom: 0;
  text-align: center;
}

.form h5 {
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.form textarea {
  width: 100%;
  border-color: #d89747;
  height: 70px;
}
.form textarea:focus {
  outline: none !important;
  border: 1px solid #d89747;
  box-shadow: 0 0 20px white;
}

.btnForm {
  display: flex;
  justify-content: space-between;
}

.btnForm .yellowBtn {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  text-transform: none;
}

.btnForm .yellowBtn p {
  margin: 0;
  color: white;
}

.btnForm .yellowBtn i {
  margin-right: 1rem;
}

.btnForm .yellowBtn:hover p,
.btnForm .yellowBtn:hover i {
  color: white;
}

#map {
  width: 100%;
  height: 15rem;
  margin: 1rem 0 0 0;
  z-index: 0;
}

.fullBtn {
  margin-top: 0.7rem;
  width: 79%;
  display: flex;
  justify-content: flex-end;
}

.fullBtn .greyBtn {
  float: right;
}

/* .vue2leaflet-map {
	z-index: -1;
} */

.descrText a {
  color: #3c4652;
}

.descrText a:hover {
  color: white;
}

.plus {
  text-align: center;
  font-weight: bold;
  padding: .5rem;
}


@media all and (max-width: 1450px) {
  .contactInfos {
    width: 90%;
  }

  .callContact {
    width: 90%;
  }

  .detailsServices {
    display: flex;
    flex-wrap: wrap;
  }

  .detailsServices {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .boxServices {
    width: 50%;
    margin-bottom: 1rem;
    text-align: center;
  }

  .blockProduct .title h1 {
    font-size: 1.7rem;
  }

  .blockProduct {
    margin-top: 3rem;
  }
}

@media all and (max-width: 1300px) {
  .btnForm {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .colRespons {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .businessHours {
    width: 23%;
  }

  .businessHours h2 {
    font-size: 1.1rem;
  }

  .allDays {
    display: flex;
    flex-direction: column;
  }
  .day {
    width: 100%;
  }

  #map {
    width: 70%;
    height: 24rem;
  }

  .blockProduct .title h1 {
    font-size: 1.4rem;
  }
}

@media all and (max-width: 1200px) {
  .contactInfos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .contactInfos p {
    width: 80%;
  }
}

@media all and (max-width: 1000px) {
  .details {
    margin: 0;
  }
}

@media all and (max-width: 930px) {
  .details {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .detailsShop,
  .detailsProduct {
    width: 80%;
    margin-top: 1rem;
  }
}

@media all and (max-width: 600px) {
  .dP2 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .promotions {
    margin-top: 1rem;
  }
  .descriptionProduct .description,
  .descriptionProduct .promotions {
    width: 100%;
  }

  .colRespons {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .businessHours {
    width: 100%;
  }

  .businessHours h2 {
    font-size: 1.1rem;
  }

  .allDays {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .day {
    width: 33%;
  }

  #map {
    width: 100%;
    height: 15rem;
  }
}
@media all and (max-width: 450px) {
  .blockProduct {
    margin: 1rem;
  }
}
</style>
